/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminNoticeDto } from '../../models/admin-notice-dto';

export interface AdminNoticeControllerDelete$Params {
  id: string;
}

export function adminNoticeControllerDelete(http: HttpClient, rootUrl: string, params: AdminNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, adminNoticeControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminNoticeDto>;
    })
  );
}

adminNoticeControllerDelete.PATH = '/api/admin-notice/{id}';
